import { styled } from '@mui/material';

export const GatewayRuleCardCollapseContent = styled('div')({
  display: 'grid',
  gridTemplateAreas: '"item item"',
  gridTemplateColumns: '50%',
  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  position: 'relative',
});
